module.exports = __webpack_public_path__ + "fonts/TTFirsNeue-DemiBold.5a0c49c8.woff2";